import App from './App.svelte'
window.showKursMap = (coord: Float64Array) => {
	const app = new App({
	target: document.getElementById('map-app'),
	props: {
			ready: false,
			coord: coord,
		}
	})
	window.initMap = function ready() {
		app.$set({ ready: true, coord: coord, });
	}
}
// export default app
